import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Tool } from "@/types";
import { toast } from "sonner";

export const useToolsData = () => {
  return useQuery({
    queryKey: ['admin-tools'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('tools')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching tools:', error);
        toast.error('حدث خطأ أثناء تحميل الأدوات');
        return [];
      }
      
      return data.map(tool => ({
        ...tool,
        imageUrl: tool.image_url,
        examples: tool.examples ? (Array.isArray(tool.examples) ? tool.examples : []).map((example: any) => ({
          title: example.title || '',
          description: example.description || ''
        })) : [],
      }));
    },
  });
};